const DEFAULT_API_BASE_URL = '/api/v1'

export const API_BASE_URL: string =
  (import.meta.env.VITE_API_BASE_URL as string | undefined)?.replace(/\/$/, '') ??
  DEFAULT_API_BASE_URL

export function apiUrl(path: string): string {
  const normalizedPath = path.replace(/^\/+/, '')
  return `${API_BASE_URL}/${normalizedPath}`
}
